/**
 * Zod schemas for the reference-data catalog API.
 * Backend issue: opentrms/opentrms issue 477.
 *
 * Backend: GET /api/v1/ref/manifest  →  RefManifest
 *          GET /api/v1/ref/:name     →  RefCatalog
 *
 * Validation is applied at the API boundary in src/api/refData.ts.
 */
import { z } from 'zod';

// ── Entry ─────────────────────────────────────────────────────────────────────

export const refEntrySchema = z.object({
  code: z.string(),
  label: z.string(),
  meta: z.record(z.string(), z.unknown()).optional(),
});

export type RefEntry = z.infer<typeof refEntrySchema>;

// ── Catalog ───────────────────────────────────────────────────────────────────

export const refCatalogSchema = z.object({
  name: z.string(),
  etag: z.string(),
  entries: z.array(refEntrySchema),
});

export type RefCatalog = z.infer<typeof refCatalogSchema>;

// ── Manifest catalog item ─────────────────────────────────────────────────────

export const refManifestCatalogSchema = z.object({
  name: z.string(),
  etag: z.string(),
  entry_count: z.number().int(),
  required_scope: z.string().nullable(),
});

export type RefManifestCatalog = z.infer<typeof refManifestCatalogSchema>;

// ── Manifest ──────────────────────────────────────────────────────────────────

export const refManifestSchema = z.object({
  manifest_version: z.string(),
  catalogs: z.array(refManifestCatalogSchema),
});

export type RefManifest = z.infer<typeof refManifestSchema>;
